module.exports = __webpack_public_path__ + "static/img/zhuzhai3.64b46591.png";